import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import AuthLayout from '../../../components/AuthLayout';

import AppContext from '../../../store/App/contexts';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const emailHandler = (e) => {
    let email = e.target.value;
    let reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

    if (reg.test(email) === false || email === null) {
      setEmail(' ');
    } else {
      setEmail(e.target.value);
    }
  };

  const passwordHandler = (e) => {
    let password = e.target.value;

    if (password === ' ') {
    } else {
      setPassword(e.target.value);
    }
  };

  return (
    <AppContext.Consumer>
      {({ loginHandler }) => (
        <AuthLayout
          title="Welcome back"
          subtitle="Sign in to your administrator workspace."
        >
          <form
            className="auth-form"
            onSubmit={(e) => loginHandler('admin', email, password, e)}
          >
            <label>Email address</label>
            <input
              className="form-control"
              type="email"
              placeholder="Email"
              onChange={(e) => emailHandler(e)}
            />
            <label>Password</label>
            <div className="auth-password-field">
              <input
                className="form-control"
                type={showPassword ? 'text' : 'password'}
                placeholder="Password"
                onChange={(e) => passwordHandler(e)}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                className="auth-password-toggle"
              >
                {showPassword ? (
                  <i
                    className="far fa-eye-slash"
                    style={{ color: '#888383', fontSize: '14' }}
                  ></i>
                ) : (
                  <i
                    className="far fa-eye"
                    style={{ color: '#888383', fontSize: '14' }}
                  ></i>
                )}
              </span>
            </div>
            <button type="submit" className="btn btn-brand w-100">
              Log in
            </button>
          </form>
          <div className="auth-link-row">
            <Link
              className="text-brand"
              to="/forgot-password/admin"
              style={{ textDecoration: 'none' }}
            >
              Forgot password?
            </Link>
          </div>
        </AuthLayout>
      )}
    </AppContext.Consumer>
  );
};

export default AdminLogin;
